import { render, staticRenderFns } from "./DeliveryFeeTiers.vue?vue&type=template&id=6d78f895&"
import script from "./DeliveryFeeTiers.vue?vue&type=script&lang=js&"
export * from "./DeliveryFeeTiers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/echope/echope-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6d78f895')) {
      api.createRecord('6d78f895', component.options)
    } else {
      api.reload('6d78f895', component.options)
    }
    module.hot.accept("./DeliveryFeeTiers.vue?vue&type=template&id=6d78f895&", function () {
      api.rerender('6d78f895', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/store/components/DeliveryFeeTiers.vue"
export default component.exports